export class UpdateMemberProfileRequest {

    Companyname: string;
    Email: string;
    Address1: string;
    City: string;
    State: string;
    Postcode: string;
    Country: string;
    Phonenumber: string;
    Phonenumber2: string;
    FaxNumber: string;

    public NewPassword: string;
    public CurrentPassword: string;

    public ValidationMessage: string;
    
    public IsPasswordValid(): boolean {

        if (this.NewPassword == undefined || this.NewPassword.length < 5) {
            this.ValidationMessage = "The new password must be at least 5 characters.";
            return false;
        }
        else if (this.CurrentPassword == undefined || this.CurrentPassword == "") {
            this.ValidationMessage = "The current password is empty.";
            return false;
        }
        else {
            this.ValidationMessage = "";
            return true;
        }
    } 

}